"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _spauiUtils = require("@tencent/spaui-utils");

var _info = _interopRequireDefault(require("./info"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Portal =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Portal, _PureComponent);

  /**
   * 属性说明
   * @alias PortalProps
   * @description 将组件的子元素渲染到 </body> 结束前，或指定的元素中。
   * @property {object} [target] 往对应位置添加展示的结构（原生浏览器节点结构），默认为body
   */
  function Portal(props) {
    var _this;

    _classCallCheck(this, Portal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Portal).call(this, props));
    _this.el = (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.createElement('div');
    _this.targetAppend = false;
    return _this;
  }

  _createClass(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var target = this.props.target;
      var body = this.getBody();

      if (typeof target === 'undefined') {
        if (body) {
          body.appendChild(this.el);
        }
      } else if (target) {
        target.appendChild(this.el);
        this.targetAppend = true;
      }

      if (typeof _reactDom.createPortal === 'undefined') {
        this.renderPortal();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var target = this.props.target;

      if (typeof target !== 'undefined' && target && !this.targetAppend) {
        target.appendChild(this.el);
        this.targetAppend = true;
      }

      if (typeof _reactDom.createPortal === 'undefined') {
        this.renderPortal();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var target = this.props.target;
      var body = this.getBody();

      if (typeof _reactDom.createPortal === 'undefined') {
        (0, _reactDom.unmountComponentAtNode)(this.el);
      }

      if (typeof target === 'undefined') {
        if (body && body.contains(this.el)) {
          body.removeChild(this.el);
        }
      } else if (target && target.contains(this.el)) {
        target.removeChild(this.el);
      }
    }
  }, {
    key: "getBody",
    value: function getBody() {
      return (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.getElementsByTagName('body')[0];
    }
  }, {
    key: "modalContent",
    value: function modalContent() {
      var children = this.props.children;
      return _react["default"].createElement("div", (0, _spauiUtils.globalProps)(this.props, {}, Portal, this.props), children);
    }
  }, {
    key: "renderPortal",
    value: function renderPortal() {
      (0, _reactDom.unstable_renderSubtreeIntoContainer)(this, // 代表当前组件
      this.modalContent(), // 塞进传送门的JSX
      this.el // 传送门另一端的DOM node
      );
    }
  }, {
    key: "render",
    value: function render() {
      if (typeof _reactDom.createPortal === 'undefined') {
        return null;
      } // 因为renderToString不支持createPortal所以要特殊hack一下
      // process.env.SSR 指明是在SSR


      if ((typeof process === "undefined" ? "undefined" : _typeof(process)) === 'object' && process && _typeof(process.env) === 'object' && process.env.SSR) {
        return null;
      }

      return (0, _reactDom.createPortal)(this.modalContent(), this.el);
    }
  }]);

  return Portal;
}(_react.PureComponent); // 组件标记


_defineProperty(Portal, "propTypes", {
  target: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.string, _spauiUtils.PropTypes.object])
});

(0, _spauiUtils.setComponentMark)(Portal, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = Portal;
exports["default"] = _default;